const getInfoContentText = (text: string, isAdmin = false) =>
  `
  Change the ${text} format that is displayed in the user interface${
    isAdmin
      ? ` for all users in this region. 
      Users can later customize this for their own user interface.`
      : "."
  }`;

export const shortDateFormatIdLegends = {
  label: "Short date format",
  infoContent: getInfoContentText("short date")
} as const;

export const longDateFormatIdLegends = {
  label: "Long date format",
  infoContent: getInfoContentText("long date")
} as const;

export const shortTimeFormatIdLegends = {
  label: "Short time format",
  infoContent: getInfoContentText("short time")
} as const;

export const longTimeFormatIdLegends = {
  label: "Long time format",
  infoContent: getInfoContentText("long time")
} as const;

export const shortDateFormatIdAdminLegends = {
  label: "Short date format",
  infoContent: getInfoContentText("short date", true)
} as const;

export const longDateFormatIdAdminLegends = {
  label: "Long date format",
  infoContent: getInfoContentText("long date", true)
} as const;

export const shortTimeFormatIdAdminLegends = {
  label: "Short time format",
  infoContent: getInfoContentText("short time", true)
} as const;

export const longTimeFormatIdAdminLegends = {
  label: "Long time format",
  infoContent: getInfoContentText("long time", true)
} as const;
